import { createFileRoute, notFound } from '@tanstack/react-router'

import { AiAssistantPage } from '@/ai-assistant/components/AiAssistantPage/AiAssistantPage'
import { FEATURE_AI_ASSISTANT } from '@/core/constants/features'

export const Route = createFileRoute('/company/_management/ai-assistant')({
  // The nav entry and the overview widget are flag-gated; the page must be too,
  // or a direct URL reaches the chat at a company without the feature.
  beforeLoad: ({ context }) => {
    if (!context.user?.features.includes(FEATURE_AI_ASSISTANT)) {
      throw notFound()
    }
  },
  component: AiAssistantPage,
})
